__turbopack_context__.v({
  "counterOfferModalContainer": "_6j4Xua_counterOfferModalContainer",
});
